import Theme from '@adsk/alloy-react-theme';

export const categoryWrapperStyle = {
  'display': 'flex',
  'padding': '16px 0 16px',
  'borderTop': `1px solid ${Theme.colors.charcoal200}`,

  '& > div': {
    minWidth: '450px',
  },

  '& > div:first-child': {
    paddingRight: '16px',
    width: '30%',
    maxWidth: '350px',
    minWidth: '150px',

    h2: {
      ...Theme.typography.heading2,
      color: Theme.colors.charcoal900,
      margin: 0,
    },

    span: {
      ...Theme.typography.bodySmall,
      color: Theme.colors.charcoal600,
    },
  },
};
